/**
 * Session keys set from Cypress `onBeforeLoad` / support helpers so auth
 * finalization cannot overwrite the hash (e.g. stale "history" → mystock)
 * even if `window.__ADS_CYPRESS_AUT` is unavailable in the AUT iframe.
 */

export const ADS_CYPRESS_AUT_STORAGE_KEY = "ads.cypress.aut";

/** Set by exchanges E2E `visitExchangesAut` only; cleared on each `window:before:load`. */
export const ADS_EXCHANGES_E2E_SESSION_KEY = "ads.e2e.exchangesFlow";
/** Set by Users E2E `visitUsersAut` only; cleared on each `window:before:load`. */
export const ADS_USERS_E2E_SESSION_KEY = "ads.e2e.usersFlow";
export const ADS_ALLOW_EXCHANGES_ROUTE_EXIT_KEY =
  "ads.e2e.allowExchangesRouteExit";

export const getIsExchangesE2eSession = () => {
  try {
    return (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(ADS_EXCHANGES_E2E_SESSION_KEY) === "1"
    );
  } catch (_e) {
    return false;
  }
};

export const getIsUsersE2eSession = () => {
  try {
    return (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(ADS_USERS_E2E_SESSION_KEY) === "1"
    );
  } catch (_e) {
    return false;
  }
};

/** True when Cypress drives a deep-link route (Exchanges or Users). */
export const getIsDeepLinkE2eSession = () =>
  getIsExchangesE2eSession() || getIsUsersE2eSession();
